import { inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { STORAGE_SERVICE_TOKEN } from '@/core/util/storage.token';
import { STORAGE_KEYS } from '@/share/constant/storage_token.key';

@Injectable()
export class UnAuthGuard implements CanActivate {
    storageService = inject(STORAGE_SERVICE_TOKEN);
    router = inject(Router);

    canActivate() {
        // return true;
        /**
         * If user already login we will not show login page
         * Automatic redirect to default page
         */
        if (this.storageService.get(STORAGE_KEYS.USER)) {
            this.router.navigate(['auth/login']).then();
            return false;
        } else {
            return true;
        }
    }
}
